var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close"},[_c('button',{staticClass:"w-b-btn",attrs:{"data-shortcut-esc":"editorCloseButton"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("閉じる")])])}
var staticRenderFns = []

export { render, staticRenderFns }